import api from './api';

export interface RoleDto {
  id: number;
  name: string;
  description?: string;
  modules: Record<string, boolean>;
  projects_list?: string | null;
  offers_list?: string | null;
}

export const listRoles = async (): Promise<RoleDto[]> => {
  try {
    const res = await api.get<{ success:boolean; data: RoleDto[] }>(`/roles`, {
      headers: { 'Cache-Control': 'no-cache' },
      params: { _t: Date.now() } // unikamy 304 i pustego body
    });
    return (res.data && (res.data as any).data) ? (res.data as any).data : [];
  } catch (e) {
    console.error('listRoles error', e);
    return [];
  }
};

export const createRole = async (payload: Partial<RoleDto>): Promise<RoleDto> => {
  const res = await api.post<{ success:boolean; data: RoleDto }>('/roles', payload);
  return res.data.data as RoleDto;
};

export const updateRole = async (id: number, payload: Partial<RoleDto>): Promise<RoleDto> => {
  const res = await api.put<{ success:boolean; data: RoleDto }>(`/roles/${id}`, payload);
  return res.data.data as RoleDto;
};

export const deleteRole = async (id: number): Promise<void> => {
  await api.delete(`/roles/${id}`);
};

export default { listRoles, createRole, updateRole, deleteRole };


